import { z } from 'zod';
import './nullableDefault';

const blockNode = z.enum([
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'blockquote',
  'p',
  'ol',
  'ul',
]);
const linkNode = z.literal('a');
const spanNode = z.literal('span');
const listItemNode = z.literal('li');

export type BlockNodeType = z.infer<typeof blockNode>;

const childText = z.object({
  text: z.string(),
  break: z.boolean().optional(),
  bold: z.boolean().optional(),
  inlineCode: z.boolean().optional(),
  italic: z.boolean().optional(),
  underline: z.boolean().optional(),
  strikethrough: z.boolean().optional(),
  classname: z.string().optional(),
});

export type ChildText = z.infer<typeof childText>;

const childLink = z.object({
  type: linkNode,
  attrs: z.object({ url: z.string(), target: z.string() }),
  uid: z.string(),
  children: z.array(childText),
});

export type ChildLink = z.infer<typeof childLink>;

const childSpan = z.object({
  type: spanNode,
  attrs: z.object({}),
  uid: z.string(),
  children: z.array(childText),
});

export type ChildSpan = z.infer<typeof childSpan>;

const childListItem = z.object({
  type: listItemNode,
  attrs: z.object({
    style: z
      .object({
        'text-align': z
          .enum(['left', 'center', 'right', 'justify'])
          .default('left'),
      })
      .optional(),
  }),
  uid: z.string(),
  children: z.array(childText),
});

export type ChildListItem = z.infer<typeof childListItem>;

const childBlock = z.object({
  type: blockNode,
  attrs: z.object({
    style: z
      .object({
        'text-align': z
          .enum(['left', 'center', 'right', 'justify'])
          .default('left'),
      })
      .optional(),
    'class-name': z.string().optional(),
  }),
  uid: z.string(),
  children: z.array(z.union([childText, childLink, childSpan, childListItem])),
});

export type ChildBlock = z.infer<typeof childBlock>;

export const contentStackJSONRichText = z
  .object({
    uid: z.string().nullableDefault().default(''),
    _version: z.number().optional(),
    attrs: z.object({}).nullableDefault().default({}),
    children: z.array(childBlock).nullableDefault().default([]),
    type: z.literal('doc').nullableDefault().default('doc'),
  })
  .nullableDefault()
  .default({
    uid: '',
    attrs: {},
    children: [],
    type: 'doc',
  });

export type ContentStackJSONRichText = z.infer<typeof contentStackJSONRichText>;
